import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Admin "Preview as Role" mode: block all mutating requests so the simulation
// can never alter real account data. Rejected with a clear, user-facing message.
let previewReadOnly = false;
export const setPreviewReadOnly = (v) => { previewReadOnly = v; };

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ag_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const method = (config.method || "get").toLowerCase();
  if (previewReadOnly && !["get", "head", "options"].includes(method)) {
    return Promise.reject({
      __preview: true,
      message: "Admin Preview is read-only — changes are disabled here.",
      response: { data: { detail: "Admin Preview is read-only — changes are disabled here." } },
    });
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
